<template>
  <div class="bg-dark text-light p-2 border border-light"
       v-show="open">
    <!-- Challenges -->
    <div id="challengeMenu"
         v-if="!selectedChallenge">
      <div
          v-for="challenge in challenges"
          :key="'challenge' + challenge.id"
          @click="selectedChallenge = challenge"
          class="link menu-item">
        {{ challenge.name }}
      </div>
    </div>
    <div
        id="selectedChallengeItem"
        v-else
        @click="selectedChallenge = null"
        class="menu-item-selected">
      {{ selectedChallenge.name }}
    </div>
    <!-- Levels -->
    <div
        id="levelMenu"
        v-if="!selectedLevel && selectedChallenge && levels.length > 1">
      <div
          v-for="level in levels"
          :key="'level' + level"
          @click="selectedLevel = level"
          class="link menu-item">
        <span class="ps-2">{{ level }}</span>
      </div>
    </div>
    <div
        id="selectedLevelItem"
        v-if="selectedLevel"
        @click="selectedLevel = null"
        class="link menu-item-selected">
      <span class="ps-2">{{ selectedLevel }}</span>
    </div>
    <!-- Leagues -->
    <div
        id="leagueMenu"
        v-if="selectedLevel && !selectedLeague && leaguesInLevel.length > 1">
      <div
          v-for="league in leaguesInLevel"
          :key="'league' + league.id"
          @click="selectedLeague = league"
          class="link menu-item">
        <span class="ps-4">{{ league.name }}</span>
      </div>
    </div>
    <div
        id="selectedLeagueItem"
        v-if="selectedLeague"
        @click="selectedLeague = null"
        class="link menu-item-selected">
      <span class="ps-4">{{ selectedLeague.name }}</span>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  props: {
    value: Object,
    open: Boolean
  },
  data() {
    return {
      challenges: [],
      leagues: [],
      selectedChallenge: null,
      selectedLevel: null,
      selectedLeague: null,
    }
  },
  computed: {
    levels() {
      let res = []
      this.leagues.forEach(l => {
        if (res.indexOf(l.levelName) < 0)
          res.push(l.levelName)
      })
      return res
    },
    leaguesInLevel() {
      if (this.selectedLevel)
        return this.leagues.filter(l => l.level === this.levels.indexOf(this.selectedLevel) + 1)
      else
        return []
    }
  },
  methods: {
    ...mapActions(['handleErrorAction']),
    updateChallengesAndLeagues() {
      this.$api('/challenges')
          .then(response => {
            this.challenges = response.data
          })
          .catch(error => this.handleErrorAction(error))
    }
  },
  watch: {
    selectedChallenge() {
      if (this.selectedChallenge)
        this.$api.get('/leagues', {
          params: {
            challenge: this.selectedChallenge.id
          }
        }).then(response => {
          let leagues = response.data
          if (leagues.length == 1) {
            this.selectedLeague = leagues[0]
            this.leagues = []
          } else
            this.leagues = response.data
        }).catch(error => this.handleErrorAction(error))
      else
        this.selectedLevel = null
    },
    selectedLevel() {
      if (this.leaguesInLevel.length == 1)
        this.selectedLeague = this.leaguesInLevel[0]
    },
    selectedLeague() {
      if (this.selectedLeague) {
        this.$emit('input', this.selectedLeague)
        this.selectedLeague = null
        this.selectedLevel = null
        this.selectedChallenge = null
      }
    }
  },
  mounted() {
    this.updateChallengesAndLeagues();
  }
}
</script>
